export { ImagePairWithText } from '@/components/common/ImagePairWithText/ImagePairWithText';
